<template>
    <b-form-checkbox
        :id="cb.name"
        v-model="status"
        value="done"
        unchecked-value="todo"
        switch
        :disabled="!canComplete"
        @change="toggle()"
    ></b-form-checkbox>
</template>

<script>
import DataUpdater from '../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'CheckTask',

    mixins: [DataUpdater],

    props: ['cb', 'done', 'canComplete'],

    computed: {
        status() {
            return this.done ? 'done' : 'todo'
        },
    },

    methods: {
        async toggle() {
            try {
                await this.$axios.put(`/clientEvents/${this.cb.id}/toggle`)
                await this.$store.dispatch('todoVM/getCounter', 'ownTasks')
                await this.$store.dispatch(
                    'todoVM/getCounter',
                    'delegatedTasks'
                )
                this.updateData()
            } catch (error) {
                // handle error
                error.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
